import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AUTO_LOAD_CONTROL } from '../config-control';
import {
  ALTERNATIVE_LOADING_STATUS,
  FAILURE_STATUS,
  IDLE_STATUS,
  LOADING_STATUS,
  SUCCESS_STATUS,
} from '../status';
import {
  fetchAll,
  fetchById,
} from './detalhamentoOperacaoSemNotaFiscalAPI';
import i18n from '../../i18n';

const initialState = {
  status: IDLE_STATUS,
  error: null,
  response: {
    status: null,
    message: null,
    data: null,
  },
  config: { control: AUTO_LOAD_CONTROL },
  list: [],
};

const fetchAllAsync = createAsyncThunk(
  'detalhamentoOperacaoSemNotaFiscal/fetchAll',
  async () => {
    const { data } = await fetchAll();
    return { data };
  }
);

const fetchByIdAsync = createAsyncThunk(
  'detalhamentoOperacaoSemNotaFiscal/fetchById',
  async (data) => {
    const response = await fetchById(data);
    return {
      response: {
        status: response.status,
        data: response.data,
      },
    };
  }
);

const detalhamentoOperacaoSemNotaFiscalSlice = createSlice({
  name: 'detalhamentoOperacaoSemNotaFiscal',
  initialState,
  reducers: {
    changeStatusTo: (state, action) => {
      state.status = action.payload.status;
    },
    loading: (state) => {
      state.status = LOADING_STATUS;
    },
    success: (state) => {
      state.status = SUCCESS_STATUS;
    },
    failure: (state) => {
      state.status = FAILURE_STATUS;
    },
    resetStatus: (state) => {
      state.status = IDLE_STATUS;
    },
    setResponse: (state, action) => {
      state.response = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    },
    clearResponse: (state) => {
      state.response = {
        status: null,
        message: null,
        data: null,
      };
    },
    resetList: (state) => {
      state.list = [];
    },
    setConfig: (state, action) => {
      state.config = action.payload;
    },
    changeControlTo: (state, action) => {
      state.config.control = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllAsync.pending, (state) => {
        state.status = ALTERNATIVE_LOADING_STATUS;
      })
      .addCase(fetchAllAsync.fulfilled, (state, action) => {
        state.status = IDLE_STATUS;
        state.list = action.payload.data;
      })
      .addCase(fetchAllAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.erroCarregarDetalhamentosOperacoesSemNotaFiscal', { erro: action.error.message }),
        };
      })
      .addCase(fetchByIdAsync.pending, (state) => {
        state.status = LOADING_STATUS;
      })
      .addCase(fetchByIdAsync.fulfilled, (state, action) => {
        if (action.payload.response.status === 200) {
          state.model = action.payload.response.data;
          state.status = SUCCESS_STATUS;
        }
      })
      .addCase(fetchByIdAsync.rejected, (state, action) => {
        state.status = FAILURE_STATUS;
        state.error = {
          ...action.error,
          message: i18n.t('com.muralis.qcx.erro.erroCarregarDetalhamentoOperacaoSemNotaFiscal', { erro: action.error.message }),
        };
      });
  },
});

const {
  changeStatusTo,
  loading,
  success,
  failure,
  preparingAction,
  resetStatus,
  changeControlTo,
  changeToConsultMode,
  changeToCreateMode,
  changeToUpdateMode,
  resetMode,
  changeToBackgroundCreateMode,
  resetBackgroundMode,
  setConfig,
  addToList,
  updateOnList,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  setModel,
  resetModel,
} = detalhamentoOperacaoSemNotaFiscalSlice.actions;

const selectDetalhamentoOperacaosSemNotaFiscal = (
  (state) => state.detalhamentoOperacaoSemNotaFiscal.list
);
const selectStatus = (state) => state.detalhamentoOperacaoSemNotaFiscal.status;
const selectError = (state) => state.detalhamentoOperacaoSemNotaFiscal.error;
const selectResponse = (state) => state.detalhamentoOperacaoSemNotaFiscal.response;
const selectConfigControl = (state) => state.detalhamentoOperacaoSemNotaFiscal.config.control;

const detalhamentoOperacaoSemNotaFiscalActions = {
  ...detalhamentoOperacaoSemNotaFiscalSlice.actions,
  selectConfigControl,
  selectStatus,
  selectError,
  selectResponse,
  selectDetalhamentoOperacaosSemNotaFiscal,
  fetchAllAsync,
  fetchByIdAsync,
};
export {
  detalhamentoOperacaoSemNotaFiscalSlice,
  changeStatusTo,
  loading,
  success,
  failure,
  preparingAction,
  resetStatus,
  changeControlTo,
  changeToConsultMode,
  changeToCreateMode,
  changeToUpdateMode,
  resetMode,
  changeToBackgroundCreateMode,
  resetBackgroundMode,
  setConfig,
  addToList,
  updateOnList,
  setResponse,
  setResponseMessage,
  clearResponse,
  setError,
  setModel,
  resetModel,
  fetchAllAsync,
  fetchByIdAsync,
  detalhamentoOperacaoSemNotaFiscalActions,
  selectDetalhamentoOperacaosSemNotaFiscal,
  selectStatus,
  selectError,
  selectResponse,
  selectConfigControl,
};

export default detalhamentoOperacaoSemNotaFiscalSlice.reducer;
